import { render, staticRenderFns } from "./HuiyiDetails.vue?vue&type=template&id=7ea8af5f&scoped=true"
import script from "./HuiyiDetails.vue?vue&type=script&lang=js"
export * from "./HuiyiDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea8af5f",
  null
  
)

export default component.exports